import axiosClient from "./axiosClient";

const userApi = {
  login: (credentials) => {
    return axiosClient.post("/users/login", credentials, {
      withCredentials: true,
    });
  },
  logout: () => {
    return axiosClient.post(
      "/users/logout",
      {},
      {
        withCredentials: true,
      }
    );
  },
  changePassword: (userId, oldPass, newPass) => {
    return axiosClient.put(
      "/users/changePassword",
      {
        usId: userId,
        oldPassword: oldPass,
        newPassword: newPass,
      },
      {
        withCredentials: true,
      }
    );
  },
  searchUsers: (customerId, keyword, page, pageSize, CusIsAdmin) => {
    const params = new URLSearchParams();
    if (customerId !== null) {
      params.append("cusId", customerId);
    }
    params.append("keyword", keyword);
    params.append("pageNumber", page > 0 ? page + 1 : 1); // +1 do page của datagrid bắt đầu từ 0
    params.append("pageSize", pageSize);
    params.append("CusIsAdmin", CusIsAdmin);

    return axiosClient.get(`/users/search?${params.toString()}`, {
      withCredentials: true,
    });
  },
  upsertUser: (userData) => {
    return axiosClient.post("/users/upsert", userData, {
      withCredentials: true,
    });
  },
  deleteUser: (usId, cusId) => {
    const params = new URLSearchParams();
    params.append("usId", usId);
    params.append("cusId", cusId);
    return axiosClient.delete(`/users/delete?${params.toString()}`, {
      withCredentials: true,
    });
  },
  SendEmailChangePassword: (usId, customerId) => {
    return axiosClient.post(
      `/users/send-email-change-password`,
      {
        usId: usId,
        customerId: customerId,
      },
      {
        withCredentials: true,
      }
    );
  },
  SendEmailChangePasswordWithEmail: (email) => {
    return axiosClient.post(
      `/users/send-email-change-password-with-email`,
      {
        email: email,
      },
      {
        withCredentials: true,
      }
    );
  },
  ChangePasswordByEmailAuth: (usId, newPass) => {
    return axiosClient.put(
      "/users/change-password-by-email-auth",
      {
        usId: usId,
        password: newPass,
      },
      {
        withCredentials: true,
      }
    );
  },
  CheckTokenChangePassword: (token) => {
    return axiosClient.get(`/users/check-token-change-password/${token}`, {
      withCredentials: true,
    });
  },
  CheckEmail: (CusId, UsEmail) => {
    return axiosClient.post(
      `/users/check-email`,
      { CusId: CusId, UsEmail: UsEmail },
      {
        withCredentials: true,
      }
    );
  },
  GetUserInfor: (customerId, userId) => {
    return axiosClient.post(
      "/users/get-user-infor",
      { customerId: customerId, userId: userId },
      { withCredentials: true }
    );
  },
};

export default userApi;
